/**
 * CommonModal 常用配置常量
 */

export const COMMON_MODAL_ICONS = {
  CHAHUA: 'https://mindverseglobal.mindverse.com/front-img/crm/1749013845196/ChaHua.png'
} as const;
